/* RESPONSIBLE TEAM: team-inbox-experience */
import Model, { attr } from '@ember-data/model';

export default class ExternalPlan extends Model {
  @attr('string') declare name: string;
  @attr('number') declare amount: number;
}
